export const ESCAPE = 'Escape'
export const TAB = 'Tab'
export const BACKSPACE = 'Backspace'
export const ARROWDOWN = 'ArrowDown'
export const ARROWUP = 'ArrowUp'
export const ENTER = 'Enter'
export const SPACE = ' '
